import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import Content from './Content.js';

gsap.registerPlugin(ScrollTrigger);

/**
 *
 */
export default class EnVrac extends Base {
  static config = {
    name: 'EnVrac',
    refs: [
      'sticky',
      'container',
      'pen',
      'pen2',
      'tshirt',
      'firstSection',
      'secondSection',
      'thirdSection',
      'title[]',
      'content[]',
    ],
    components: {
      Content,
    },
  };

  /**
   *
   */
  mounted() {
    if (window.matchMedia('(max-width: 63.999rem)').matches) {
      return;
    }

    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.$refs.firstSection,
        scrub: 0.6,
        markers: false,
        start: '10% center',
        end: '40% top',
        toggleActions: 'restart none none none',
      },
    });

    this.tl.fromTo(
      this.$refs.pen,
      { yPercent: 100 },
      {
        yPercent: 0,
        ease: 'power4.out',
      },
    );

    this.tl.to(this.$refs.pen, {
      scale: 1,
      rotate: 0,
      ease: 'power4.out',
    });

    this.tlbis = gsap.timeline({
      scrollTrigger: {
        trigger: this.$refs.secondSection,
        scrub: 0.6,
        markers: false,
        start: '10% center',
        end: '80% center',
        toggleActions: 'restart none none none',
      },
    });

    const penLeftValue = window.matchMedia('(max-width: 64rem)').matches ? 120 : 88;

    this.tlbis.to(this.$refs.pen, {
      left: penLeftValue,
      top: 4,
      ease: 'power4.out',
    });

    // Gestion de l'opacité du tshirt séparée du scrub pour éviter le délai
    ScrollTrigger.create({
      trigger: this.$refs.secondSection,
      start: '50% center',
      end: '99% center',
      onEnter: () => gsap.to(this.$refs.tshirt, { opacity: 1, duration: 0.4, ease: 'power4.out' }),
      onLeaveBack: () =>
        gsap.to(this.$refs.tshirt, { opacity: 0, duration: 0.4, ease: 'power4.out' }),
    });

    ScrollTrigger.create({
      trigger: this.$refs.thirdSection,
      start: '25% center',
      onEnter: () => gsap.to(this.$refs.tshirt, { opacity: 0, duration: 0.4, ease: 'power4.out' }),
      onLeaveBack: () =>
        gsap.to(this.$refs.tshirt, { opacity: 1, duration: 0.4, ease: 'power4.out' }),
    });

    this.tlthree = gsap.timeline({
      scrollTrigger: {
        trigger: this.$refs.thirdSection,
        scrub: 0.6,
        markers: false,
        start: '10% bottom',
        end: '40% center',
        toggleActions: 'restart none none none',
      },
    });

    const penLeftValueThree = window.matchMedia('(max-width: 64rem)').matches ? 20 : 100;
    const penScaleValueThree = window.matchMedia('(max-width: 64rem)').matches ? 1 : 2;

    this.tlthree.to(this.$refs.pen, {
      scale: penScaleValueThree,
      rotate: 30,
      left: penLeftValueThree,
      ease: 'power4.out',
    });

    this.tlthree.to(this.$refs.pen2, {
      opacity: 1,
      ease: 'power4.out',
    });
  }
}
